import { Routes } from '@angular/router';
import { Valid8PageComponent } from '@layouts/valid8-page/valid8-page.component';

export const routes: Routes = [
  {
    path: 'login',
    component: Valid8PageComponent,
    loadChildren: () => import('@features/login/login.route'),
  },

  {
    path: 'forgot-password',
    component: Valid8PageComponent,
    loadChildren: () => import('@features/forgot-password/forgot-password.route'),
  },

  {
    path: 'reset-password',
    component: Valid8PageComponent,
    loadChildren: () => import('@features/reset-password/reset-password.route'),
  },

  {
    path: 'change-password',
    component: Valid8PageComponent,
    loadChildren: () => import('@features/change-password/change-password.route'),
  },

  {
    path: '',
    loadChildren: () => import('@layouts/main-page/main-page.route'),
  },

  {
    path: 'documents/:token/upload',
    component: Valid8PageComponent,
    loadChildren: () => import('@features/external-upload/external-upload.route'),
  },

  { path: '**', redirectTo: '' },
];
